var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 19.747-7.572 5.737L15.97 7.14V7l.03.07.029-.07v.14l7.542 18.344L16 19.747zm-4.98-3.361-2.592-1.037V9.533l3.685 4.606-1.094 2.246zm-3.168 8.58L1 13.391l9.5 4.088-2.648 7.486zM16 21.185l.029-.02v.04l6.045 4.278H9.925l6.046-4.278v-.04l.03.02zm4.98-4.8 2.592-1.037V9.533l-3.685 4.606 1.094 2.246zm3.168 8.58L31 13.391l-9.5 4.088 2.648 7.486z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeak);
export default __webpack_public_path__ + "static/media/PEAK.165028304e24ca009a5150eb32a06a67.svg";
export { ForwardRef as ReactComponent };